export default __webpack_public_path__ + "static/media/Vector.f8fc4c73.svg";